import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmailAllowed } from 'constants/delete-user.constants';
import { useAllowedDeleteUserEmails } from 'hooks/useAllowedDeleteUserEmails';
import { IAppReducer } from 'models/reducer.interface';

interface DeleteUserGuardProps {
  children: React.ReactNode;
}

export const DeleteUserGuard = ({ children }: DeleteUserGuardProps) => {
  const user = useSelector((state: IAppReducer) => state.authReducer);
  const navigate = useNavigate();
  const { allowedEmails, isLoading, error } = useAllowedDeleteUserEmails();

  useEffect(() => {
    // Si aún está cargando, no hacer nada
    if (isLoading) return;

    // Verificar que el usuario sea customer service
    if (user.role !== 'customer service') {
      navigate('/settings');
      return;
    }

    // Verificar que el email esté en la lista de emails permitidos
    if (!isEmailAllowed(user.email, allowedEmails)) {
      navigate('/settings');
      return;
    }
  }, [user.role, user.email, allowedEmails, isLoading, navigate]);

  // Si está cargando, mostrar loading
  if (isLoading) {
    return <div>Cargando...</div>;
  }

  // Si hay error, redirigir
  if (error) {
    navigate('/settings');
    return null;
  }

  // Si no cumple con los requisitos, no renderizar nada
  if (
    user.role !== 'customer service' ||
    !isEmailAllowed(user.email, allowedEmails)
  ) {
    return null;
  }

  return <>{children}</>;
};
